const prospectsTypes = {

  resend: {
    request: "RESEND_PROPSECT_REQUEST",
    success: "RESEND_PROPSECT_SUCCESS",
    failure: "RESEND_PROPSECT_FAILURE"
  },

  export: {
    request: "EXPORTS_XLSX_PROPSECTS_REQUEST",
    success: "EXPORTS_XLSX_PROPSECTS_SUCCESS",
    failure: "EXPORTS_XLSX_PROPSECTS_FAILURE"
  },

  index: {
    request: "PROPSECTS_INDEX_REQUEST",
    success: "PROPSECTS_INDEX_SUCCESS",
    failure: "PROPSECTS_INDEX_FAILURE"
  },

  destroy: {
    request: "DESTROY_PROSPECT_REQUEST",
    success: "DESTROY_PROSPECT_SUCCESS",
    failure: "DESTROY_PROSPECT_FAILURE"
  },

  set_errors: "SET_PROSPECT_ERRORS"
}

export default prospectsTypes



// WEBPACK FOOTER //
// ./src/js/constants/prospectsTypes.js